import { Box, Stack, StackProps } from '@mui/material';
import Line from '@upheal/shared/components/shared/Line';

type PricingCardLayoutProps = {
    title: React.ReactNode;
    price: React.ReactNode;
    cta?: React.ReactNode;
    ctaPlacement?: 'middle' | 'bottom' | 'none';
    descriptionCaption?: React.ReactNode;
    descriptionDetails: React.ReactNode;
    isHighlighted?: boolean;
    isDimmed?: boolean;
} & Omit<StackProps, 'title'>;
export const PricingCardLayout = (props: PricingCardLayoutProps) => {
    const {
        title,
        price,
        cta,
        ctaPlacement = 'middle',
        descriptionCaption,
        descriptionDetails,
        isHighlighted,
        isDimmed,
        ...rest
    } = props;

    return (
        <Stack
            spacing={2}
            {...rest}
            sx={{
                width: 240,
                p: 2,
                pb: 3,
                backgroundColor: (theme) =>
                    isDimmed
                        ? theme.palette.offWhite.main
                        : theme.palette.ds.bg.neutral.primary,
                borderRadius: '9.375px',
                border: (theme) =>
                    `${isHighlighted || isDimmed ? 2 : 1}px solid ${
                        isHighlighted
                            ? theme.palette.ds.fg.accent2.primary
                            : isDimmed
                            ? theme.palette.lightNew.main
                            : theme.palette.ds.border.neutral.secondary
                    }`,
                boxShadow: (theme) =>
                    theme.palette.ds.effects.shadow.neutral.md,
                ...rest.sx,
            }}
        >
            {title}
            {price}
            {ctaPlacement === 'middle' && cta}
            {descriptionCaption && (
                <Stack spacing={1}>
                    <Line />
                    {descriptionCaption}
                    <Line />
                </Stack>
            )}
            <Box flexGrow={1}>{descriptionDetails}</Box>
            {ctaPlacement === 'bottom' && cta}
        </Stack>
    );
};
